import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// NB: niente withCredentials globale. Same-origin invia comunque il cookie httpOnly;
// cross-origin (produzione) usa il Bearer qui sotto, evitando il conflitto CORS "*" + credenziali.
const api = axios.create({ baseURL: API });

// Same-origin (app deployata: frontend e backend sullo stesso dominio) → invia il cookie
// httpOnly persistente (10 anni con "Ricordami"). Cross-origin (preview) resta Bearer-only
// per evitare il conflitto CORS "*" + credenziali.
try {
  if (new URL(BACKEND_URL).origin === window.location.origin) {
    api.defaults.withCredentials = true;
  }
} catch (e) { console.warn("BACKEND_URL non valido per il controllo same-origin", e); }

// Fallback Bearer: usato quando i cookie httpOnly non sono disponibili
// (es. browser mobile cross-origin che bloccano i cookie di terze parti)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (detail.isAxiosError || detail.response) return formatApiError(detail.response?.data?.detail);
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export default api;
